import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getOneSmaster=(id,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_ONE_SMASTER_START
    })
    const options={
        url:`${api}/smasters/${id}`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_ONE_SMASTER_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_ONE_SMASTER_FAIL,
                payload:getMessage(error)
            }))
}